import API from "../../../services/api";

import "./NotificationCard.css";

function NotificationCard({

    notification,

    onReload,

}) {

    const handleAction = async (button) => {

        try {

            await API({

                url: button.api,

                method: button.method,

            });

            onReload();

        }

        catch (error) {

            console.error(error);

        }

    };

    return (

        <div className="notification-card">

            <div className="notification-header">

                <h3>

                    {notification.title}

                </h3>

                {

                    !notification.read && (

                        <span className="unread-dot"></span>

                    )

                }

            </div>

            <p>

                {notification.message}

            </p>

            {

                notification.data && (

                    <div className="notification-order">

                        <div>

                            <strong>

                                Customer

                            </strong>

                            <span>

                                {notification.data.customerName}

                            </span>

                        </div>

                        <div>

                            <strong>

                                Order

                            </strong>

                            <span>

                                {notification.data.orderNumber}

                            </span>

                        </div>

                        <div>

                            <strong>

                                Amount

                            </strong>

                            <span>

                                ₹{Number(

                                    notification.data.amount || 0

                                ).toLocaleString("en-IN")}

                            </span>

                        </div>

                    </div>

                )

            }

            {

                notification.actionRequired && (

                    <div className="notification-actions">

                        {

                            notification.actionButtons.map(

                                (button, index) => (

                                    <button

                                        key={index}

                                        onClick={() =>

                                            handleAction(button)

                                        }

                                        className={

                                            button.action === "accept"

                                                ? "accept-btn"

                                                : "reject-btn"

                                        }

                                    >

                                        {button.label}

                                    </button>

                                )

                            )

                        }

                    </div>

                )

            }

        </div>

    );

}

export default NotificationCard;